import {Skeleton} from '@sollapay/ui/components';

import {TrustAccountGridCard} from './TrustAccountGridCard';

import type {FC} from 'react';

export interface TrustAccountGridCardSkeletonProps {
  /** Active cards open with the balance panel; setup cards don't. */
  withBalance?: boolean;
}

export const TrustAccountGridCardSkeleton: FC<TrustAccountGridCardSkeletonProps> = ({
  withBalance = true
}) => (
  <TrustAccountGridCard
    balance={withBalance && <Skeleton className="h-24 w-full rounded-lg" />}
    identity={
      <div className="flex items-start gap-3">
        <Skeleton className="size-11.5 shrink-0 rounded-md" />
        <div className="flex flex-1 flex-col gap-2">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-24" />
        </div>
      </div>
    }
    meta={
      withBalance && (
        <div className="flex justify-between">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-4 w-16" />
        </div>
      )
    }
    footerStart={
      <div className="flex items-center gap-2">
        <Skeleton className="size-6 rounded-full" />
        <Skeleton className="h-3 w-6" />
      </div>
    }
    footerEnd={<Skeleton className="h-4 w-24" />}
  />
);
